import { CommonStore } from '../common-store';

const storeModule = new CommonStore(
  'camp/cities',
  { name: 'camp.cities' }
);

export default {
  namespaced: storeModule.namespaced,
  state: storeModule.state,
  getters: storeModule.getters,
  actions: storeModule.actions,
  mutations: storeModule.mutations
};
